var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEuroCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 5C2 3.89543 2.89543 3 4 3H20C21.1046 3 22 3.89543 22 5V7.25H2V5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 8.75V15C2 16.1046 2.89543 17 4 17H10.5764C10.5261 16.674 10.5 16.3401 10.5 16C10.5 12.4101 13.4101 9.5 17 9.5C19.0104 9.5 20.8077 10.4127 22 11.8464V8.75H2Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 21C19.7614 21 22 18.7614 22 16C22 13.2386 19.7614 11 17 11C14.2386 11 12 13.2386 12 16C12 18.7614 14.2386 21 17 21ZM17.5 19.75C15.9623 19.75 14.6407 18.8244 14.062 17.5H14C13.5858 17.5 13.25 17.1642 13.25 16.75C13.25 16.4234 13.4588 16.1455 13.7502 16.0426L13.75 16L13.7502 15.9574C13.4588 15.8545 13.25 15.5766 13.25 15.25C13.25 14.8358 13.5858 14.5 14 14.5H14.062C14.6407 13.1756 15.9623 12.25 17.5 12.25C18.1818 12.25 18.8232 12.4326 19.3755 12.7521C19.7341 12.9595 19.8566 13.4183 19.6492 13.7769C19.4418 14.1354 18.983 14.258 18.6245 14.0506C18.2943 13.8596 17.9111 13.75 17.5 13.75C16.8336 13.75 16.2349 14.0397 15.8229 14.5H16.5C16.9142 14.5 17.25 14.8358 17.25 15.25C17.25 15.6642 16.9142 16 16.5 16C16.9142 16 17.25 16.3358 17.25 16.75C17.25 17.1642 16.9142 17.5 16.5 17.5H15.8229C16.2349 17.9603 16.8336 18.25 17.5 18.25C17.9111 18.25 18.2943 18.1404 18.6245 17.9494C18.983 17.742 19.4418 17.8646 19.6492 18.2231C19.8566 18.5817 19.7341 19.0405 19.3755 19.2479C18.8232 19.5674 18.1818 19.75 17.5 19.75Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEuroCard);
export default __webpack_public_path__ + "static/media/euro-card.18071fd699cee0abab1a69f4c3dbc1e8.svg";
export { ForwardRef as ReactComponent };